export default {

    category: function(collection, key, value){
        var parameters = [key, value];
        return collection.filter(function(value, key, collection) {
            for(let i = 0; i < parameters[1].length; i++) {
                if(collection[key][parameters[1][i]] === 1) {
                    return collection[key];
                }
            }
        }, parameters)
    },

    verspaanbaarheid: function(collection, key, value){
        return this.filterRadioButton(collection,key,value);
    },

    taaiheid: function(collection, key, value){
        return this.filterRadioButton(collection,key,value);
    },

    slijtvastheid: function(collection, key, value){
        return this.filterRadioButton(collection,key,value);
    },

    maatvastheid: function(collection, key, value) {
        return this.filterRadioButton(collection,key,value);
    },

    corrosiebestendigheid: function(collection, key, value){
        return this.filterRadioButton(collection,key,value);
    },

    filterRadioButton: function(collection, key, value) {
        var parameters = [key, value];
        return collection.filter(function(value, key, collection) {
            if(collection[key][parameters[0]] > parameters[1]) {
                return collection[key];
            }
        }, parameters)
    },

    trekvastheid: function(collection, key, value) {
        var parameters = [key, value];
        return collection.filter(function(value, key, collection) {
            if(collection[key][parameters[0]] >= parameters[1][0] && collection[key][parameters[0]] <= parameters[1][1]) {
                return collection[key];
            }
        }, parameters);
    },

    hardheid_hrc: function(collection, key, value) {
        var parameters = [key, value];
        return collection.filter(function(value, key, collection) {
            if(collection[key][parameters[0]] >= parameters[1][0] && collection[key][parameters[0]] <= parameters[1][1]) {
                return collection[key];
            }
        }, parameters)
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/steelfilter/helpers/filter.js